function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
import { debounce } from '@cloud-sn/v-utils';
import commonMixin from './mixins/common';
import { getTitle } from './utils';
var __vue_script__ = {
  name: 'MenuItem',
  mixins: [commonMixin],
  props: {
    name: {
      type: [String, Number],
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item");
    },
    isSelected: function isSelected() {
      var selectedItemEventNames = this.selectedItemEventNames,
          eventName = this.eventName;
      return selectedItemEventNames.indexOf(eventName) > -1;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          disabled = this.disabled,
          isSelected = this.isSelected,
          activeItemEventName = this.activeItemEventName,
          eventName = this.eventName;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-selected"), isSelected), _defineProperty(_ref, "".concat(prefixCls, "-active"), !disabled && activeItemEventName === eventName), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    }
  },
  created: function created() {
    this.debounceOnClick = debounce(this.onClick, 50);
    this.rootMenu.addDescendants(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.rootMenu.removeDescendants(this);
  },
  methods: {
    onMenuActive: function onMenuActive(e) {
      this.rootMenu.onMenuActive(e);
    },
    onMenuItemClick: function onMenuItemClick(e) {
      this.rootMenu.onMenuItemClick(e);
    },
    onMenuItemDeselect: function onMenuItemDeselect(e) {
      this.rootMenu.onMenuItemDeselect(e);
    },
    onMenuItemSelect: function onMenuItemSelect(e) {
      this.rootMenu.onMenuItemSelect(e);
    },
    onMouseEnter: function onMouseEnter() {
      this.onMenuActive({
        item: this,
        hover: true
      });
    },
    onMouseLeave: function onMouseLeave() {
      this.onMenuActive({
        item: this,
        hover: false
      });
    },
    onClick: function onClick(e) {
      var isSelected = this.isSelected,
          disabled = this.disabled,
          isMultiple = this.isMultiple,
          onMenuItemClick = this.onMenuItemClick,
          onMenuItemDeselect = this.onMenuItemDeselect,
          onMenuItemSelect = this.onMenuItemSelect;

      if (disabled) {
        return;
      }

      var event = {
        item: this,
        name: this.eventName,
        eventPath: [this.eventName],
        domEvent: e
      };
      onMenuItemClick(event);

      if (isSelected) {
        if (isMultiple) {
          onMenuItemDeselect(event);
        }
      } else {
        onMenuItemSelect(event);
      }
    },
    getAttrTitleVal: function getAttrTitleVal(slotTitle, title) {
      var hasTitleAttr = this.hasTitleAttr;
      return hasTitleAttr ? getTitle(slotTitle, title) : '';
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    class: _vm.classes,
    style: [_vm.paddingStyle],
    attrs: {
      "title": _vm.getAttrTitleVal(_vm.$slots.default, _vm.title)
    },
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "click": _vm.debounceOnClick
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "menuItem.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);